import { ShareholderRecord, } from '../classes/shared';
import { initNumbersFromNotes } from './initNumbersFromNotes';

//  Attempts to create ShareNumbers fior the records and return a new array.
//  If it fails it returns the given array,

export function initNumbers({
  records,
  timeStamp,
  eventRef,
  silent,
}: {
  records: Array<ShareholderRecord>;
  timeStamp: number;
  eventRef: string;
  shareCount?: { [shareclassId: string]: number };
  silent?: boolean;
}): ShareholderRecord[] {
  let ret: ShareholderRecord[] = records;
  ret = initNumbersFromNotes({
    records,
    timeStamp,
    eventRef,
  });
  return ret;
}
